import {Injectable} from '@angular/core';
import * as componentActions from '@catdetails/actions/properties';
import {Store} from '@ngrx/store';

@Injectable()
export class ProjectPropertiesService {
  constructor(private store: Store<any>) {
  }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PROPERTIES_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PROPERTIES_DEACTIVATE});
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/services/project-properties.service.ts